import React, { Component } from "react";
import {FormBlocks} from '../FormBlocks';
import {formFieldsAttributes} from '../../../FormBuilderFunctions/FieldProps';
// import { getUserAuthorities } from '../../../../../Utils/UserFunctions';
import {
  addSelectedMultiLookupAction,
  // onChangeInputAction,
  setSelectedMultiLookupAction,
  removeSelectedMultiLookupAction,
  selectOrUnselect
} from '../../../../../store/actions/formBuilderActions';
import * as actions from '../../../../../store/actions';
import { isSet,getSelectedValueBasedOnField, IsJsonString, resolveMultiLookupDisplayText, getMultiLookupEntryDisplayName, getHardCodedIds, getMultiLookupIdListFromField, normalizeMultiLookupEntries} from '../../../../../Utils/CommonFunctions';
import { getFieldPropertiesFromGridList } from '../../../../../Containers/LayoutContainer/LayoutCommonFunction';
import { callPOST,callGET } from "../../../../../Utils/ApiUtil";
import MultiLookupModal from './MultiLookupModal';
import ReactTags from '../../../../ReactTags';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Icons from '../../../../Icons/Icons';
import WindowIcons from '../../../../Icons/WindowIcon';
import { getProfileAuthorities, getWindowIcons} from "../../../../../Utils/UserFunctions";
import { LOOKUP_API_FIELD_ID,API_STATUS_SUCCESS,USERS_WINDOW_ID,RATE_SHEET_WINDOW_ID,ORGANIZATION_WINDOW_ID,EMAIL_WINDOW_ID,PROFILE_WINDOW_ID,NOTES_WINDOW_ID,CUSTOM_WINDOW_ID,ADDITIONAL_LAYOUT_FIELDS } from '../../../../../Global/Constants';
const KeyCodes = {
  comma: 188,
  enter: 13,
};
let delimiters = [KeyCodes.comma, KeyCodes.enter];

class MultiLookup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen:false,
      displayName:'',
      lookupSuggestionData:[],
      multiLookupData:[],
      lookup_layout:{},
      relatedWindowFields:[],
      isConfirmPage:false,
      tableRecords:{
        tableHead:[],
        tableData:[], 
        pagination:{
          page:0,
          orderBy:'',
          perPage:10,
          direction:'ASC',
          totalRecords:0,
          search:''
        }
      },
      isLoading:false,
    }
    this.selectAllDisplayText = [
      {
        label: `All ${this.props.item.value}`,
        check: true,
        text: `All ${this.props.item.value}`
      }
    ];
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
    this.presetEnrichInFlight = false;
    this.presetEnrichKey = '';
  }

  getActiveMultiLookupTags = () => {
    const { item } = this.props;
    const fromRedux = isSet(item.stateValue, []);
    if (fromRedux.length > 0) {
      return fromRedux.map((tag) => ({ ...tag }));
    }
    return [...this.state.multiLookupData];
  }

  normalizeMultiLookupRecordId = (rawId) => {
    if (!rawId) {
      return '';
    }
    return String(rawId).replace(/ggg$/, '');
  }

  /** Keep ReactTags in sync when Redux clears/sets Ship To (e.g. To Address tailgate preset). */
  syncMultiLookupDisplayFromField = () => {
    const { item } = this.props;
    const fromRedux = isSet(item.stateValue, []);
    if (fromRedux.length > 0) {
      this.setState({ multiLookupData: fromRedux.map((tag) => ({ ...tag })) });
      return;
    }
    const ids = getMultiLookupIdListFromField(item);
    if (ids.length === 0) {
      this.setState({ multiLookupData: [] });
      return;
    }
    const raw = String(isSet(item.selectedValue, '')).trim();
    if (IsJsonString(raw)) {
      const tags = normalizeMultiLookupEntries(item).map((entry) => {
        const id = entry.id || entry.meta_table_id || '';
        const label = entry.name || entry.label || id;
        return {
          label,
          text: label,
          value: id,
          id: id ? id + 'ggg' : undefined,
        };
      }).filter((tag) => tag.value);
      if (tags.length) {
        this.setState({ multiLookupData: tags });
      }
    }
  }

  getTagsForRender = () => {
    const { item } = this.props;
    const { multiLookupData } = this.state;
    if (item.required_query === true) {
      return this.selectAllDisplayText;
    }
    const fromRedux = isSet(item.stateValue, []);
    if (fromRedux.length > 0) {
      return fromRedux;
    }
    if (getMultiLookupIdListFromField(item).length === 0) {
      return [];
    }
    return multiLookupData;
  }
  
  componentDidMount = ()=>{
    this.LayoutsFormsList('',true);
    this.restoreStepsFilterWindowTags();
    const {item,selectedMultiLookup,screen} = this.props;
    // console.log('this.props',this.props);
    if(isSet(selectedMultiLookup[item.id],[]).length>0 && isSet(screen,null)==='Layout'){
      this.confirmSelectedMultiLookup(isSet(selectedMultiLookup[item.id],[]));
    }
  }
  componentDidUpdate = (prevProps)=>{
    if(prevProps.item.selectedValue!==this.props.item.selectedValue){
      this.setSelectedMultiLookupForUpdate();
      this.restoreStepsFilterWindowTags();
    }
    if (
      prevProps.item.selectedValue !== this.props.item.selectedValue
      || prevProps.item.stateValue !== this.props.item.stateValue
    ) {
      this.syncMultiLookupDisplayFromField();
      this.tryEnrichShipToPresetTagsFromRecordList();
    }
  }

  restoreStepsFilterWindowTags = () => {
    const { item, screen } = this.props;
    if (isSet(screen, 'Layout') !== 'Steps' || !isSet(item.selectedValue, '')) {
      return;
    }
    try {
      if (IsJsonString(item.selectedValue)) {
        let parsed = JSON.parse(item.selectedValue);
        // Single selection is often a bare object, not [{...}]
        if (parsed && !Array.isArray(parsed)) {
          parsed = [parsed];
        }
        if (!Array.isArray(parsed) || parsed.length === 0) {
          return;
        }
        const tags = parsed.map((entry) => {
          const displayName = getMultiLookupEntryDisplayName(entry)
            || resolveMultiLookupDisplayText(entry.fieldGroups?.[0]?.data?.[0]?.selectedValue);
          const id = isSet(entry.meta_table_id, isSet(entry.id, ''));
          return {
            label: displayName || id,
            text: displayName || id,
            value: id,
            id,
          };
        }).filter((tag) => tag.id);
        if (tags.length) {
          this.setState({ multiLookupData: tags });
        }
        return;
      }
      const rawValue = String(item.selectedValue).trim();
      if (!rawValue) {
        return;
      }
      const displayName = isSet(item.displayValue, rawValue);
      const ids = rawValue.split(',').map((id) => id.trim()).filter(Boolean);
      const names = String(displayName).split(',').map((name) => name.trim());
      const tags = ids.map((id, index) => ({
        label: names[index] || id,
        text: names[index] || id,
        value: id,
        id,
      }));
      if (tags.length) {
        this.setState({ multiLookupData: tags });
      }
    } catch (e) {
      // ignore malformed saved values
    }
  }
   //MODAL POPUP FOR ADD NEW - OPEN
   openMultiLoopupModalHandler = () =>{
     if(this.props.item.modType!=='LAYOUT'){
      //this.props.clearSelectedMultiLookup();
     }
    this.setState({isModalOpen:true});
    // console.log(this.state);
  }
  //MODAL POPUP - CANCEL
  cancelMultiLoopupModalHandler = () =>{
    this.props.selectOrUnselect(false)
    this.setState({isModalOpen: false});
  }
  multiLookupChangeHandler = ()=>{}

  setMultiLookupValuesFromList = (res) =>{
    this.setState({displayName:res.label});
    // console.log('res',res);
    this.props.onChangeInputAction(this.props.fieldObj,{
      selectedValue:res.value,
      displayValue:res.label,
      stateValue:res.stateValue,
      required_query:res.required_query,
      related_window_fields:res.related_window_fields,
      ruleMapping:res.ruleMapping
    },'MultiLookup');
  }
  render() {
    const  {
      // type,
      item,
      className,
      // section,
      validationForms,
      // subformObj
    } = this.props;

    const {
      // displayName
    } = this.state;

    // const updateData = {
    //   section_index:section.section_index,
    //   itemIndex:item.itemIndex,
    //   item:item,
    //   ...subformObj
    // }
    // const item = {...this.props.item,required_query:true};
    const WindowProfile = getProfileAuthorities();
    const svgIcons =getWindowIcons();
    let windowIcon ="";
    let isSystemIcon=true;
    let htmlCode ='';
    let sourceImage='';
    WindowProfile.data.windows.map((window) => {
        if(window.window_name===item.value & window.window_icon!==undefined ){
          windowIcon=window.window_icon;
          isSystemIcon=window.is_system_icon;
          if(window.is_system_icon===false){ 
            svgIcons.map((svg,i)=>{
              if(svg.id===window.window_icon){
                htmlCode=svg.icon_name;
                sourceImage = 'data:image/svg+xml;base64,'+svg.svg_icon;	
              }
            });
          }
        }
    })
    const {lookupSuggestionData,multiLookupData}  = this.state; 
    const attr = formFieldsAttributes(
      {...item,className:className,hideMandatory:true
    },validationForms);
    

    let readonlyVal = false;
    if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
       readonlyVal = attr.fieldAttributes.readOnly;
    }
    
    
      // console.log('required_query',item.required_query,item.label.blocks[0].text);
      return (
        <Wrp>
        <FormBlocks {...this.props}  attr={attr}>
          <div className="input-group autocomplete">
            <input 
                type="hidden"
                value={(item.selectedValue && item.selectedValue!==null)?item.selectedValue:(item.default_value!==null)?item.default_value:''}
                {...attr.fieldAttributes}
                autoComplete="new-lookup" />
             <ReactTags
                tags={this.getTagsForRender()}
                // readOnly={false}
                placeHolder={'Search..'}
                suggestions={(isSet(item.has_related_window,false)===true || item.required_query===true)?[]:lookupSuggestionData.filter((itm)=>{
                  if(multiLookupData.findIndex(i=>i.value===itm.value)===-1){
                    return itm;
                  }
                })
                }
                delimiters={delimiters}
                handleDelete={this.handleDelete}
                handleAddition={this.handleAddition}
                handleDrag={this.handleDrag}
                clickHandler={(isSet(item.has_related_window,false)===true)?this.openMultiLoopupModalHandler:()=>{this.handleInputChange('')}}
                handleInputChange={this.handleInputChange}
                handleTagClick={this.handleTagClick} 
                readOnly={readonlyVal} />
                {(this.state.isLoading===true) &&
                  <i
                    className="fas fa-spinner fa-spin fa-lg"
                    style={{
                      position: "absolute",
                      top: "35%",
                      right: "60px", // Adjust based on your padding
                      transform: "translateY(-50%)",
                      color: "#000", // Customize loader color
                      zIndex: '999'
                    }}></i>
                }
          <div className={(item.required===true)? "input-group-append mandatory":"input-group-append"} onClick={readonlyVal !== true ? this.openMultiLoopupModalHandler : null}> <a className="input-group-text">
            {/* <i className={this.state.lookupIcon}></i> */}
            {/* <Icons iconType={item.value} size={16} color={'#000'}/> */}
            {isSet(windowIcon,null)!==null?(!isSystemIcon?
									<img src={sourceImage}  width='17' height='17' />
									// <div className="Container" dangerouslySetInnerHTML={{__html: htmlCode}}></div>
								   :<WindowIcons size={17} color = {'#000'}windowIcon={windowIcon}/>):
                   <Icons iconType={item.value} size={17} color={'#000'}/>
								}
            </a></div>  
          </div>
          </FormBlocks>  
      {(item.modType!=='LAYOUT' && this.state.isModalOpen)?
        <MultiLookupModal 
            item={item} 
            {...this.props}
            isModalOpen={this.state.isModalOpen} 
            windowName={item.value}
            selectedValue={item.selectedValue}
            updateInHidden={true}
            required_query={item.required_query}
            tableRecords={this.state.tableRecords}
            isConfirmPage={this.state.isConfirmPage}
            onChangeSelectLookup={this.onChangeSelectLookup}
            updateTableRecords={this.updateTableRecords}
            updateConfirmState={this.updateConfirmState}
            updateSuggestionLookup={this.updateSuggestionLookup}
            cancelMultiLoopupModalHandler={this.cancelMultiLoopupModalHandler} 
            setMultiLookupValuesFromList={this.setMultiLookupValuesFromList}
          />
        : ''}
        </Wrp>
    );
  }


  LayoutsFormsList =(value,isDefault=false) =>{
    const restrictedFields = ["add", "edit", "clone"]
    const {item} = this.props;    
    if(item.modType==='LAYOUT'){ return false; }
    if(item.is_subform===true){ return false; }// my code 07 - Avoid subform exception
    const params = this.props.match.params;
    const paramsPage = isSet(params.page,'');
    const page = 0;
    const orderBy = ''; 
    const perPage = 10;
    const direction = 'ASC';
    const search = value;
    // if(value.toString().trim()==='' && isDefault===false){
    //   return false;
    // }
    //console.log('item==',item)
    //console.log('windowID==',this.props.windowID)
    this.setState({isLoading:true});
    
    let API_URL = '';
    let lookupWindowNameId = isSet(this.props.windowID,'');
    let isFromScreen = isSet(this.props.screen,'Layout');
    const queryString1 = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;    
    const filterWindowId = isSet(item.lookup_window_id, lookupWindowNameId);
    const isProfileFilterWindow = filterWindowId === PROFILE_WINDOW_ID
      || isSet(item.field_name, '') === 'Loggedin User Profile'
      || isSet(item.lookup_window_name, '') === 'Loggedin User Profile';
    if(isFromScreen === 'Steps' && isProfileFilterWindow){
      API_URL = LOOKUP_API_FIELD_ID[PROFILE_WINDOW_ID]+queryString1;
      callGET(API_URL)
        .then(response => {
          this.setState({isLoading:false});
          const responseData = response.data;
          if(responseData.code === API_STATUS_SUCCESS && responseData.data && responseData.data.content) {
            const updateTableData = responseData.data.content.map((arr) => ({
              label: arr.profile_name,
              text: arr.profile_name,
              value: arr.id,
              id: arr.id
            }));
            this.setState({lookupSuggestionData: updateTableData.length > 0 ? updateTableData : [{text:'No records found'}]});
          } else {
            this.setState({lookupSuggestionData:[{text:'No records found'}]});
          }
        }, () => {
          this.setState({isLoading:false, lookupSuggestionData:[{text:'No records found'}]});
        });
    }else if((isFromScreen === 'Steps') && (ADDITIONAL_LAYOUT_FIELDS.indexOf(isSet(item.field_name,'')) > -1) && (lookupWindowNameId!=='' && lookupWindowNameId!==null && lookupWindowNameId!==undefined)){
      //lookupWindowNameId = item.dependent_layout.window_id
      if(item.field_name === 'Notes'){
        API_URL = LOOKUP_API_FIELD_ID[NOTES_WINDOW_ID]+queryString1;
        API_URL = API_URL.replace('{WINDOW_ID}', lookupWindowNameId);
        callGET(API_URL)
        .then(response => {
          this.setState({isLoading:false});
            const responseData = response.data;
            if(responseData.code === API_STATUS_SUCCESS) {
              let datalist = [];//ORGANIZATION_WINDOW_ID === lookupWindowNameId ? responseData.data.organization_list.content : responseData.data.content;
              if(ORGANIZATION_WINDOW_ID === lookupWindowNameId) {
                if(responseData.data.organization_list.content) {
                  datalist = responseData.data.organization_list.content;
                }
              }else if(responseData.data && responseData.data.content) {
                datalist = responseData.data.content;
              }else if(CUSTOM_WINDOW_ID === lookupWindowNameId) {
                if(responseData.data.windows.content) {
                  datalist = responseData.data.windows.content;
                }
              }
              let updateTableData = [];
              if(datalist.length > 0) {
              
                datalist.map((arr,i) => {
                  let value = '';
                  if(item.field_name === 'Notes') {
                    value = {
                            label:arr.note_content ? arr.note_content.substring(0, 20) : '',
                            text:arr.note_content ? arr.note_content.substring(0, 20) : '',
                            value:arr.id,
                            id:arr.id
                          }
                  }
                  
                  updateTableData.push(value);
                })
              }
              if(updateTableData && updateTableData.length > 0) {
                  this.setState({lookupSuggestionData: updateTableData}); 
                }else {
                  updateTableData.push({
                      text:'No records found'
                  });
                  this.setState({lookupSuggestionData: updateTableData});
                }
            }else {
              this.setState({lookupSuggestionData:[{
                    text:'No records found'
                }]});
            }
          }, (error) => {
              console.log(error);
              this.setState({lookupSuggestionData:[{
                  text:'No records found'
              }]});
          }).catch(err => {
            this.setState({isLoading:false});
          }) 
      }            
    }else{
        const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction+'&parent_layout_id='+params.layoutId+'&parent_window_id='+params.windowId;
      if (!restrictedFields.includes(paramsPage.toLowerCase())) {
        API_URL = 'table-data-engine/' + item.value + '/metatable/record-list/active' + queryString;

      } else {
        API_URL = 'table-data-engine/' + item.value + '/metatable/record-list' + queryString;

      }
       callPOST(API_URL,{})
        .then(res => {
          this.setState({isLoading:false});
          if(res.status===200){ 
            const response = res.data;
            if(response.code===200){              
              let updateTableData = [];
              let fieldsRow = [];
              let fieldsRowData;
              let defaultDisFieldsRow = [];
              this.setState({lookup_layout:{
                lookupLayoutId:response.data.lookup_layout_id,
                moduleId:response.data.module_id,
                windowId:response.data.window_id,
                windowName:this.props.item.value
              }});
              let tablehead = [
                {
                  name:'',
                  type:"Checkbox",
                  columnName:"",
                  isShow:true,
                  attributes:{style:{width: "30px"}}
                }
              ]
              const headAction = {
                header:{
                  checked:true,
                  name:'windowCheckbox',
                  isShow:true,
                },
                headerKey:'Checkbox'
              }
              response.data.grid_list.map((header)=>{
                tablehead.push({
                  name:header.display_name,
                  type:"HyperLink",
                  columnId:header.table_descriptor_id,
                  isShow:header.is_show,
                });
              }) 
              
              const gridList = response.data.grid_list;
              const layout_rule_map = isSet(response.data.layout_rule_map,{});
              response.data.value_list.content.map((contentData)=>{
                fieldsRow = [];
                fieldsRowData  = {};
                defaultDisFieldsRow = [];
                fieldsRowData = {
                  ...fieldsRowData,
                  [headAction.headerKey]:{...headAction.header}
                };
                tablehead.map((column,headIndex)=>{
                  if(headIndex>0){
                    fieldsRowData = {
                      ...fieldsRowData,
                      [column.columnId]:{
                        className:'',
                        value:''
                      },
                    } 
                  }
                });
              contentData.fields.map((item,itemIndex)=>{
                tablehead = [...tablehead].map((column)=>{
                  if(item.table_descriptor_id===column.columnId){
                    let dataType = '';
                    if(item.element_type === 'Barcode') {
                      dataType = 'Barcode';
                    }else if(item.element_type==='Image' && item.files.length===0) {
                      dataType = 'Image';
                    }else if(item.element_type==='CheckBoxes') {
                      dataType = 'Others';
                    }else if(item.element_type!=='Image') {
                      dataType = 'HyperLink';
                    }else {
                      dataType = 'Image';
                    }
                    column.type = dataType;
                  }
                  return column;
                });
                item.selectedValue = item.value;
                item.element = (item.element_type==='PickList' || item.element_type==='MultiSelect' || item.element_type==='File'  || (item.element_type==='Image' && item.files.length===0))?'TextInput':item.element_type;
                item.options = [];
                const selectedValue = getSelectedValueBasedOnField(item);
                const displayText = resolveMultiLookupDisplayText(selectedValue);
                if(displayText!=='' && displayText!=='-'){
                  fieldsRowData = {
                    ...fieldsRowData,
                    [item.table_descriptor_id]:{
                          className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
                          isDefaultDisplay:isSet(item.is_default_displayname,false),
                          value:selectedValue,
                          label:item.label,
                    }
                  }
                    const apiFieldName = item.api_custom_field_name || item.api_field_name;
                    if(apiFieldName==='is_active'){ return; }
                    fieldsRow.push(displayText);
                    if(isSet(item.is_default_displayname,false)===true){
                      defaultDisFieldsRow.push(displayText);
                    }
                  }
            });
            const endPos = (fieldsRow.length<=2)? fieldsRow.length:3;
            fieldsRow = (defaultDisFieldsRow.length===0)?fieldsRow.slice(0,endPos):defaultDisFieldsRow;
            // const meta_table_id = (contentData.metaTableId)?contentData.metaTableId:contentData.meta_table_id
            updateTableData.push({
              label:fieldsRow.join(' '),
              data:{
                clickHandler:this.onChangeSelectLookup.bind(this,contentData.meta_table_id),
                className:"selected",
                isSelected:true,
                rowId:contentData.meta_table_id,
                data:fieldsRowData
              },
              value:contentData.meta_table_id,
              id:contentData.meta_table_id+'ggg',
              ruleMapping:isSet(layout_rule_map[contentData.meta_table_id],{}),
              text:fieldsRow.join(' '),
            });
          });
              this.setState({lookupSuggestionData:updateTableData});
              if(isDefault) this.setSelectedMultiLookupForUpdate(); 
              
            }else{
              this.setState({lookupSuggestionData:[]});
            }
          }
        })
    }        
    //console.log('API_URL==',API_URL)
    //callPOST('table-data-engine/'+item.value+'/metatable/record-list/active'+queryString,{})
  }
    // DELETE/CANCEL ADDED LOOKUP VALUES
    handleDelete(i) {
      const {item} = this.props;
      if(i!==-1){
        let updateSelectedData = [...this.getActiveMultiLookupTags().filter((tag, index) =>{
            if(index !== i){
              return tag;
            }
          }),
        ]
      // this.props.fieldGroups.forEach((arr)=>{
      //    arr.data.map((val)=>{
      //     if(val.element==='MultiLookup' && item.id===val.id){
      //         val.required_query=false
      //     }
      //     return val
      //   })
      // })
         this.props.selectOrUnselect(false)
         if(item.required_query===true){
          setTimeout(() => {
            this.props.onChangeInputAction(this.props.fieldObj,{
               required_query:false,
             },'MultiLookup');
          }, 0);
           updateSelectedData=[];
         }
      this.updateSuggestionLookup(updateSelectedData);
        // console.log('updateSelectedData',updateSelectedData,i);
        // this.setState({multiLookupData:updateSelectedData});
        // this.updateSuggestionLookup(updateSelectedData);
      }
    }
    //ADD WHEN SELECT FROM SUGGESTION
    handleAddition =(tag) =>{
        const {item} = this.props;
        if(tag.value===undefined){
        }else{
          const tagId = this.normalizeMultiLookupRecordId(isSet(tag.value, tag.id));
          const existing = this.getActiveMultiLookupTags();
          const alreadySelected = existing.some(
            (entry) => this.normalizeMultiLookupRecordId(isSet(entry.value, entry.id)) === tagId
          );
          if (alreadySelected) {
            return;
          }
          let updateSelectedData = [...existing, tag];
          this.updateSuggestionLookup(updateSelectedData,true);
        }
    }

    buildMultiLookupTagFromRecordRow = (contentData, layout_rule_map, tablehead, headAction) => {
      let fieldsRow = [];
      let fieldsRowData = {
        [headAction.headerKey]: { ...headAction.header },
      };
      let defaultDisFieldsRow = [];
      contentData.fields.map((fieldItem, itemIndex) => {
        fieldItem.selectedValue = fieldItem.value;
        fieldItem.element = (fieldItem.element_type==='PickList' || fieldItem.element_type==='MultiSelect' || fieldItem.element_type==='File'  || (fieldItem.element_type==='Image' && fieldItem.files.length===0))?'TextInput':fieldItem.element_type;
        fieldItem.options = [];
        const selectedValue = getSelectedValueBasedOnField(fieldItem);
        const displayText = resolveMultiLookupDisplayText(selectedValue);
        if(displayText!=='' && displayText!=='-'){
          fieldsRowData = {
            ...fieldsRowData,
            [fieldItem.table_descriptor_id]:{
              className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
              isDefaultDisplay:isSet(fieldItem.is_default_displayname,false),
              value:selectedValue,
              label:fieldItem.label,
            },
          };
          const apiFieldName = fieldItem.api_custom_field_name || fieldItem.api_field_name;
          if(apiFieldName==='is_active'){ return; }
          fieldsRow.push(displayText);
          if(isSet(fieldItem.is_default_displayname,false)===true){
            defaultDisFieldsRow.push(displayText);
          }
        }
      });
      const endPos = (fieldsRow.length<=2)? fieldsRow.length:3;
      fieldsRow = (defaultDisFieldsRow.length===0)?fieldsRow.slice(0,endPos):defaultDisFieldsRow;
      const metaId = contentData.meta_table_id;
      return {
        label:fieldsRow.join(' '),
        data:{
          clickHandler:this.onChangeSelectLookup.bind(this, metaId),
          className:'selected',
          isSelected:true,
          rowId: metaId,
          data:fieldsRowData,
        },
        value: metaId,
        id: metaId + 'ggg',
        ruleMapping:isSet(layout_rule_map[metaId],{}),
        text:fieldsRow.join(' '),
      };
    }

    tagNeedsRecordListEnrich = (tag) => {
      const ruleMapping = tag.ruleMapping;
      if (!ruleMapping || typeof ruleMapping !== 'object') {
        return true;
      }
      return Object.keys(ruleMapping).length === 0;
    }

    tryEnrichShipToPresetTagsFromRecordList = () => {
      const { item, match } = this.props;
      if (item.api_custom_field_name !== 'ship_to_additional_services' || item.modType === 'LAYOUT') {
        return;
      }
      const tags = this.getActiveMultiLookupTags();
      if (!tags.length || !tags.some((tag) => this.tagNeedsRecordListEnrich(tag))) {
        return;
      }
      const enrichKey = tags.map((t) => this.normalizeMultiLookupRecordId(isSet(t.value, t.id))).sort().join(',');
      if (this.presetEnrichInFlight || enrichKey === this.presetEnrichKey) {
        return;
      }
      const tailgateServiceId = getHardCodedIds('tailgateDeliveryAuthorizedId');
      let searchQuery = '';
      if (tailgateServiceId && tags.some((tag) => {
        return this.normalizeMultiLookupRecordId(isSet(tag.value, tag.id)) === tailgateServiceId
          && this.tagNeedsRecordListEnrich(tag);
      })) {
        searchQuery = getHardCodedIds('tailgateDeliveryAuthorizedLabel') || 'Tailgate';
      }
      const params = match.params;
      const queryString = '?query='+encodeURIComponent(searchQuery)+'&page=0&orderBy=&size=10&direction=ASC&parent_layout_id='+params.layoutId+'&parent_window_id='+params.windowId;
      const API_URL = 'table-data-engine/' + item.value + '/metatable/record-list/active' + queryString;
      this.presetEnrichInFlight = true;
      callPOST(API_URL, {})
        .then((res) => {
          this.presetEnrichInFlight = false;
          if (res.status !== 200 || !res.data || res.data.code !== 200) {
            return;
          }
          const response = res.data;
          const layout_rule_map = isSet(response.data.layout_rule_map, {});
          const headAction = {
            header:{ checked:true, name:'windowCheckbox', isShow:true },
            headerKey:'Checkbox',
          };
          const contentList = isSet(response.data.value_list.content, []);
          const tagById = {};
          tags.forEach((tag) => {
            const id = this.normalizeMultiLookupRecordId(isSet(tag.value, tag.id));
            if (id) {
              tagById[id] = tag;
            }
          });
          let didEnrich = false;
          const enriched = tags.map((tag) => {
            const id = this.normalizeMultiLookupRecordId(isSet(tag.value, tag.id));
            if (!this.tagNeedsRecordListEnrich(tag)) {
              return tag;
            }
            const contentData = contentList.find((row) => row.meta_table_id === id);
            if (!contentData) {
              return tag;
            }
            didEnrich = true;
            return this.buildMultiLookupTagFromRecordRow(contentData, layout_rule_map, [], headAction);
          });
          if (didEnrich) {
            this.presetEnrichKey = enrichKey;
            this.updateSuggestionLookup(enriched, false);
          }
        })
        .catch(() => {
          this.presetEnrichInFlight = false;
        });
    }
    updateSuggestionLookup = async (multiLookupData,isAuto=false)=>{
      const {item,itemIndex} = this.props;
      // console.log('multiLookupData',item,multiLookupData);
      let selectedIds = [];
      let displayNames = [];
      let tableRowData = [];
      let relatedWindowFields = [];
      let rulesMapping = [];
      let requiredQuery = item.required_query;
      multiLookupData.forEach((selectedLookup)=>{
        selectedIds.push(selectedLookup.value);
        tableRowData.push(selectedLookup.data);
        displayNames.push(selectedLookup.label);
        rulesMapping.push(selectedLookup.ruleMapping);
        relatedWindowFields.push(selectedLookup.related_window_fields);
      });
      if(isAuto===true){
         this.updateConfirmState(true);
      }
      // console.log('relatedWindowFields',C);
      if(isSet(relatedWindowFields,[]).length===0){
         relatedWindowFields = isSet(item.related_window_fields,[]);
      }
      // console.log('this.props.selectAll',this.props.selectAll);
      if(this.props.selectAll && multiLookupData.length>0){
        requiredQuery = true;
        //  this.props.fieldGroups.forEach((arr)=>{
        //  arr.data.map((val)=>{
        //   if(val.element==='MultiLookup' && item.id===val.id){
        //       val.required_query=true
        //       // selectedIds = [];
        //       // displayNames = [];
        //       // multiLookupData = [];
        //   }
        //   return val
        // })
      // })
      }
      // else{
      //      this.props.fieldGroups.forEach((arr)=>{
      //       arr.data.map((val)=>{
      //         if(val.element==='MultiLookup' && item.id===val.id){
      //             val.required_query=false
      //         }
      //         return val
      //       })
      //   })
      // }
      await this.props.setSelectedMultiLookupAction(tableRowData,item.id);
      this.setMultiLookupValuesFromList({
        value:selectedIds.join(','),
        label:displayNames.join(','),
        ruleMapping:rulesMapping,
        stateValue:multiLookupData,
        required_query:requiredQuery,
        related_window_fields:isSet(relatedWindowFields,[])});
      this.setState({
        multiLookupData:multiLookupData
      });
    }

    //DRAG AND SORT SELECTED/ADDED LOOKUP VALUES
    handleDrag(tag, currPos, newPos) {
      // const tags = [...this.state.tags];
      // const newTags = tags.slice();
  }

    //HANDLER CLICK
    handleTagClick(index,actionType) {
        // console.log('sugg',index,actionType);
        if(actionType==='click'){
            // console.log('The tag at index ' + index + ' was clicked');
        }else if(actionType==='doubleclick'){
            // console.log(this.state.tags[index]);
            // this.setState({activeIndex:index,activeTag:this.state.tags[index]});
            // var inputField = this.refs.customToogleAddTags;
            // inputField.click();
            // console.log('The tag at index ' + index +' was double clicked');
        }
    }
    //SEARCHING AND LIST VALUES FROM LIST ON KEYUP
    handleInputChange = (suggestion)=>{
      this.LayoutsFormsList(suggestion);
    }
    updateTableRecords = (updateRecords)=>{
      this.setState({tableRecords:{
        ...updateRecords
      }})
    }
    updateConfirmState = (bool)=>{
      this.setState({isConfirmPage:bool})
    }
    onChangeSelectLookup = (rowId)=>{
      const tableDataSel = this.state.tableRecords;
      if(isSet(tableDataSel.tableHead[0].checked===true,false)===true){
        tableDataSel.tableHead[0].checked=false;
        }
      tableDataSel.tableData.data.map((item,index)=>{
          if(item.rowId===rowId){
            const tableData = tableDataSel.tableData.data[index].data;
            let validation = [];
            let validationIds = [];
            Object.entries(tableData).map(([key, column]) => {
              if(Object.keys(isSet(column.item,{})).length>0){
                if(isSet(column.item.selectedValue,null)===null){
                  validationIds.push(key);
                  validation.push(column.item.label.blocks[0].text+' must be required');
                }
              }
            })
            if(validation.length>0){
              try{
                // console.log('validate',index+'_'+validationIds[0]);
                document.getElementById(index+'_'+validationIds[0]).focus();
              }catch(e){

              }
              this.props.failMessage(validation.join('</br>'));
              return false;
            }
            // console.log('this.props',this.props);
            // if(validation.length>0){
            //   this.props.failMessage(validation.join('</br>'));
            //   return false;
            // }
            const columnId = tableDataSel.tableHead[1].columnName;
            let isChecked;
            isChecked = tableDataSel.tableData.data[index].data.Checkbox.checked;
            tableDataSel.tableData.data[index].className=(isChecked)? '':'selected';
            tableDataSel.tableData.data[index].isSelected=(isChecked)? false:true;
            tableDataSel.tableData.data[index].data.Checkbox.checked=(isChecked)? false:true;
  
            if(tableDataSel.tableData.data[index].data.Checkbox.checked){
                //Add Redux state for selected Multilook rows
              // console.log('tableDataSel.tableData.data[index]',tableDataSel.tableData.data[index]);
              this.props.addSelectedMultiLookupAction(tableDataSel.tableData.data[index],this.props.item.id);
            }else{
                //Remove Redux state for selected Multilook rows
                this.props.selectOrUnselect(false)
              this.props.removeSelectedMultiLookupAction(tableDataSel.tableData.data[index].rowId,this.props.item.id);
            }
          }
      });
        this.updateTableRecords(tableDataSel);
      }

  // setSelectedMultiLookupTagForEdit = async () => {
  //   try {
  //     const { item } = this.props;
  //     const { lookupSuggestionData } = this.state;
  //     if (item.selectedValue !== undefined && IsJsonString(item.selectedValue)) {
  //       let selectedValueJSON = JSON.parse(item.selectedValue);
  //       let selectedMetaTableIds = new Array();
  //       selectedValueJSON.map((item, index) => {
  //         const meta_table_id = (item.metaTableId) ? item.metaTableId : item.meta_table_id;
  //         selectedMetaTableIds.push(meta_table_id);
  //       })
  //       for (let value of lookupSuggestionData) {
  //         let contentArray = [];
  //         if (selectedMetaTableIds.includes(value.value)) {
  //           contentArray.push(value)
  //           await this.handleAddition(value)

  //         }
  //       }
  //     }
  //   } catch (e) {
  //     console.log(e);

  //   }
  // }
 
  setSelectedMultiLookupForUpdate = ()=>{  
    try {
      const {item} = this.props;
      
      if(item.selectedValue!==undefined && IsJsonString(item.selectedValue)){
      let selectedValueJSON = JSON.parse(item.selectedValue);
      // Single selection is often a bare object, not [{...}]
      if (selectedValueJSON && !Array.isArray(selectedValueJSON)) {
        selectedValueJSON = [selectedValueJSON];
      }
      if (!Array.isArray(selectedValueJSON)) {
        selectedValueJSON = [];
      }
      // console.log('selectedValueJSON',selectedValueJSON);
        this.iterateAndSetTableData(this.state.tableRecords.tableHead,selectedValueJSON,{
          header:{
            checked:true,
            isShow:true,
            isSelected:true,
            name:'windowCheckbox'
          },
          headerKey:'Checkbox'
         },selectedValueJSON.length,1);
        }
    }catch (e) {
      console.log(e);
        
    }
  }
  iterateAndSetTableData = (tablehead,content,headAction,totalRecords,isRefillOnEdit=0,layout_rule_map={})=>{
    const {item} = this.props;
    const {related_window_fields} = item;
    let updateTableData = [];
    let fieldsRow;
    // console.log('onecontent',content);
    content.map((contentData)=>{
      fieldsRow = {}
        fieldsRow = {
          ...fieldsRow,
          [headAction.headerKey]:{...headAction.header}
        };
        fieldsRow = {
          ...fieldsRow,
          ['Checkbox']:{
            checked: (isRefillOnEdit===1)?true:false,
            columnId: "checkbox",
            isShow: true,
            name: "windowCheckbox",
            changeHandler:()=>this.props.onChangeSelectLookup(meta_table_id),
          }
      }
       isSet(tablehead,[]).map((column,headIndex)=>{
          if(headIndex>0){
            fieldsRow = {
              ...fieldsRow,
              [column.columnId]:{
                className:'',
                value:''
              },
            } 
          }
        });
        
        
        // Optimized record-list returns fields[] with fieldGroups:[]; prefer non-empty fieldGroups only
        if(Array.isArray(contentData.fieldGroups) && contentData.fieldGroups.length > 0){
          contentData.fieldGroups.map((section)=>{
            
            section.data.map((item,itemIndex)=>{
              // console.log('content - dummy',item);
                    fieldsRow = {
                        ...fieldsRow,
                        [item.id]:{
                            tableDescId:item.id,
                            label:isSet(item.label.blocks[0].text,''),
                            className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
                            value:getSelectedValueBasedOnField(item),
                            isDefaultDisplay:isSet(item.is_default_displayname,false),
                            clickHandler:()=>this.props.onChangeSelectLookup(meta_table_id),
                        }
                    }
                    // console.log('content -field',fieldsRow);
            })
          });
        }else if(Array.isArray(contentData.fields)){
          contentData.fields.map((item,itemIndex)=>{
            tablehead = [...tablehead].map((column)=>{
              if(item.table_descriptor_id===column.columnId){
                let dataType = '';
                if(item.element_type === 'Barcode') {
                  dataType = 'Barcode';
                }else if(item.element_type==='Image' && item.files.length===0) {
                  dataType = 'Image';
                }else if(item.element_type==='CheckBoxes') {
                  dataType = 'Others';
                }else if(item.element_type!=='Image') {
                  dataType = 'HyperLink';
                }else {
                  dataType = 'Image';
                }
                column.type = dataType;
              }
              return column;
            });
            
            item.selectedValue = item.value;
            item.element = (item.element_type==='PickList' || item.element_type==='MultiSelect' || item.element_type==='File'  || (item.element_type==='Image' && item.files.length===0))?'TextInput':item.element_type;
            item.options = [];
            const selectedValue = getSelectedValueBasedOnField(item);
            if(selectedValue!=='' && selectedValue!==undefined && selectedValue!==null && selectedValue!=='-'){
              fieldsRow = {
                ...fieldsRow,
                [item.table_descriptor_id]:{
                      className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
                      isDefaultDisplay:isSet(item.is_default_displayname,false),
                      value:selectedValue,
                      tableDescId:item.table_descriptor_id,
                      label:item.label,
                      clickHandler:()=>this.props.onChangeSelectLookup(meta_table_id),
                }
              }
            }
        });
        }
        if(isRefillOnEdit===0 && isSet(item.has_related_window,false)===true){
          isSet(related_window_fields,[]).map((rltGrp,rltIndex)=>{
            if(rltIndex>0){ return false; }
            isSet(isSet(rltGrp,{fieldGroups:[]}).fieldGroups,[]).map((sec)=>{
              sec.data.map((itm)=>{
                if(itm.linking_window_field ===true || itm.element==='MultiLookup'){ 
                  return false;
                }
                 fieldsRow = {
                ...fieldsRow,
                [itm.id]:{
                    className:'',
                    item:{...itm,selectedValue:''},
                    section:sec,
                    changeHandler:(updateItm,e,inputType)=>this.onChangeRelatedField(meta_table_id,itm.id,updateItm,e,inputType)
                }
              }
              })
            })
          })
        }
      //  console.log('content-fieldsRow',fieldsRow);
      const meta_table_id = (contentData.metaTableId)?contentData.metaTableId:contentData.meta_table_id
      updateTableData.push({
          className:(isRefillOnEdit===1)?'checked':'',
          rowId:meta_table_id,
          ruleMapping:isSet(layout_rule_map[meta_table_id],{}),
          data:fieldsRow
      })
    });
    this.updateTableRecords({
      tableData:{data:updateTableData,status:200},
      tableHead:tablehead,
      pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
    });
    
    this.setState({status:200});
    if(isRefillOnEdit===1){
      this.props.setSelectedMultiLookupAction(updateTableData,this.props.item.id);
      // setTimeout(() => {
         this.confirmSelectedMultiLookup(updateTableData,isRefillOnEdit);
      // },100)
    }
  }
  confirmSelectedMultiLookup = (selectedMultiLookup,isRefillOnEdit,isSubmit=0)=>{
    let lookupDataArr = [];
    let validation = [];
    let updatedRelatedWindowFields = (isSet(this.props.item.related_window_fields,[]).length>0)?
      isSet(this.props.item.related_window_fields[0],{}):
      [];
      let relatedWindowFieldsValue = [];
    selectedMultiLookup.map((item,itemIndex)=>{
        relatedWindowFieldsValue = [];
        let displayNameColumn = [];
        let defaultDisplay = [];
        updatedRelatedWindowFields = (isSet(this.props.item.related_window_fields,[]).length>0)?
      isSet(this.props.item.related_window_fields[0],{}):
      [];
        Object.entries(item.data).map(([fieldId,rowData],i) =>{
          if(isSet(rowData.item,null)!==null){
            updatedRelatedWindowFields = {
              ...updatedRelatedWindowFields,
              fieldGroups:[...updatedRelatedWindowFields.fieldGroups].map((sec)=>{
                return{
                  ...sec,
                  data:sec.data.map((itm)=>{
                    let updateItm = {...itm}
                    if(itm.id===rowData.item.id){
                      if(isSet(rowData.item.selectedValue,null)===null){
                        selectedMultiLookup[itemIndex].data[fieldId] = {
                          ...selectedMultiLookup[itemIndex].data[fieldId],
                          ['validation']:itm.label.blocks[0].text+' must be required'
                        }
                        validation.push(itm.label.blocks[0].text+' must be required');
                      }
                      updateItm = {
                        ...updateItm,
                        ...rowData.item
                      }
                    }
                    return updateItm;
                  })
                }
              })
            }
          }
          // console.log('rowData',rowData);
            if(rowData.value!=='' && rowData.value!==undefined && rowData.value!=='-'){  
              // const property  = getFieldPropertiesFromGridList(this.props.tableRecords.tableHead,rowData.tableDescId);
              const property  = getFieldPropertiesFromGridList(this.state.tableRecords.tableHead,fieldId);
              const displayText = resolveMultiLookupDisplayText(rowData.value);
              if(displayText && (isSet(property.is_default_displayname,false)===true || isSet(rowData.isDefaultDisplay,false)===true)){
                defaultDisplay.push(displayText);
              }
              
              if(displayText){
                displayNameColumn.push(displayText); 
              }
            }

            return rowData;
        })
        // console.log('multiLookupData,defaultDisplay',defaultDisplay);
        const endPos = (item.data.length<=2)? item.data.length:2;
        displayNameColumn = (defaultDisplay.length===0)?displayNameColumn.slice(0,endPos):defaultDisplay;
        lookupDataArr.push({
          label:displayNameColumn.join(' '),
          text:displayNameColumn.join(' '),
          id:item.rowId,
          value:item.rowId,
          ruleMapping:item.ruleMapping,
          data:item,
          related_window_fields:updatedRelatedWindowFields,
        })
        return item;
    });  
    if(validation.length>0){
      this.props.failMessage('Sorry, there was something wrong with the given data. Please check and try again');
      return false;
    }
      this.updateSuggestionLookup(lookupDataArr);
  
    this.updateTableRecords({
      ...this.state.tableRecords,
      tableData:{data:selectedMultiLookup,status:200},
    });
  }
}

MultiLookup.defaultProps = {
  className: "form-control custom-arrow",
}


const mapDispatchToProps = dispatch => {
  return {
    addSelectedMultiLookupAction:(data,id)=>dispatch(addSelectedMultiLookupAction(data,id)),
    removeSelectedMultiLookupAction:(data,id)=>dispatch(removeSelectedMultiLookupAction(data,id)),
    setSelectedMultiLookupAction:(data,id)=>dispatch(setSelectedMultiLookupAction(data,id)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg)),
    warningMessage : (msg) => dispatch(actions.warningMessage(msg)),
    selectOrUnselect:(bool) => dispatch(selectOrUnselect(bool))
    // onChangeInputAction:(data,e,type)=>dispatch(onChangeInputAction(data,e,type))
  };
}
const mapStateToProps = (state,props) => { 
  return {
    selectedMultiLookup : state.formBuilder.selectedMultiLookup,
    selectAll:state.formBuilder.selectAll
  };
}
export default
  connect(
    mapStateToProps, 
    mapDispatchToProps
  )(withRouter(MultiLookup));